module.exports = __webpack_public_path__ + "img/shizuha aki_sc1.43e5fac3.png";